const qs = (sel, ctx = document) => ctx.querySelector(sel);
const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

document.addEventListener('DOMContentLoaded', () => {
  const popup = qs('.js-o2-consent-popup');
  const accept = qs('.js-o2-consent-accept');
  const reject = qs('.js-o2-consent-reject');
  if (!popup || !accept || !reject) return;
  const storageKey = 'o2pets_privacy_consent_v1';
  let choice = null;
  try { choice = window.localStorage.getItem(storageKey); } catch (error) {}
  popup.hidden = choice === 'yes' || choice === 'no';

  const saveChoice = (allowed) => {
    popup.hidden = true;
    const apply = () => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || !privacy.setTrackingConsent) return;
      try {
        privacy.setTrackingConsent({analytics: allowed, marketing: allowed}, (result) => {
          if (result && result.error) return;
          try { window.localStorage.setItem(storageKey, allowed ? 'yes' : 'no'); } catch (error) {}
        });
      } catch (error) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy) {
      apply();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      try {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
          if (!error) apply();
        });
      } catch (error) {}
    }
  };
  accept.addEventListener('click', () => saveChoice(true));
  reject.addEventListener('click', () => saveChoice(false));
});
